import React, { useEffect, useState } from 'react'
import IOSPermissionPrompt from '../../Components/iOSPermissionPrompt'
import { MICROPHONE_STATES } from '../HardwareChecks'
import cx from 'classnames'
import PointingArrow from './PointingArrow'
import StudentInstruction from '../../Components/StudentInstruction'
import { COPY_STRINGS } from '../../../../constants/translatedCopy'
import RaiseHand from '../../Components/PreCheckIllustrations/RaiseHand'
import { getCopyByGradeband } from '../../../../services/ThemingService'

export default function IOSMicrophonePermissionPrompt({speechProps, setPermissionState, readyToPrompt, raiseYourHand}) {

    const [ showPermissionPrompt, setShowPermissionPrompt ] = useState(readyToPrompt)
    const [ tappedAllow, setTappedAllow ] = useState(false)

    useEffect(()=>{
        setShowPermissionPrompt(readyToPrompt)
    }, [readyToPrompt])

    const triggerWrongButtonSpeech = async () => {
        const speakWrongButtonPrompt = async ()=>{
            await speechProps.speakWithPromise({textToSpeak: getCopyByGradeband(COPY_STRINGS, 'student_checks').prompt_ios_device_mic_modal_error})
        }
        speechProps.abortDance()
        speechProps.abortSpeech(speakWrongButtonPrompt)
    }

    const triggerOSPermissionRequestPrompt = async () => {
        const speakCorrectButtonPrompt = async () => {
            await speechProps.speakWithPromise({textToSpeak: getCopyByGradeband(COPY_STRINGS, 'student_checks').prompt_ios_device_mic_modal_success})
            speechProps.initializeRecorderIfNeeded(handleDenied,() => speechProps.abortSpeech(handleAllowed))
        }
        setTappedAllow(true)
        setShowPermissionPrompt(false)
        speechProps.abortDance()
        speechProps.abortSpeech(speakCorrectButtonPrompt)
    }

    const handleAllowed = async () => {
        await speechProps.speakWithPromise({textToSpeak: getCopyByGradeband(COPY_STRINGS, 'student_checks').prompt_ios_device_mic_modal_got_it})
        setPermissionState(MICROPHONE_STATES.granted)
    }

    const handleDenied = (error) => {
        setPermissionState(MICROPHONE_STATES.denied)
    }

    if(raiseYourHand){
        return <StudentInstruction>
            <RaiseHand/>
        </StudentInstruction>
    }

    if(!showPermissionPrompt) return null

    const classes = cx({
        "tapped-allow": tappedAllow
    })

    return (
        <div className='ios-microphone-permission-prompt'>
            <IOSPermissionPrompt
                classes={classes}
                title="Can I use the Microphone?"
                tappedAllow={tappedAllow}
                onReject={triggerWrongButtonSpeech}
                onAccept={triggerOSPermissionRequestPrompt} />
            <PointingArrow pointingDirection="up"/>
        </div>
    )
}
